exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".q-edit-content[data-v-4643baf4] {\n  margin-top: 10px;\n}\n.q-edit-content[data-v-4643baf4]  .error-msg {\n    position: absolute;\n    color: #fc5659;\n    padding-left: 10px;\n    line-height: 20px;\n    font-size: 12px;\n}\n", ""]);

// exports
